import { create } from "zustand"

interface CommentStore {
	refetchFlag: number
	requestRefetch: () => void
}

export const useCommentStore = create<CommentStore>(set => ({
	refetchFlag: 0,

	requestRefetch: () =>
		set(state => ({ refetchFlag: state.refetchFlag + 1 })),
}))
